import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\CommissionNote\ReorderCommissionNoteItemsController::__invoke
* @see app/Http/Controllers/CommissionNote/ReorderCommissionNoteItemsController.php
* @route '/api/commission-note/{commission_note}/items-order'
*/
const ReorderCommissionNoteItemsController = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: ReorderCommissionNoteItemsController.url(args, options),
    method: 'put',
})

ReorderCommissionNoteItemsController.definition = {
    methods: ["put"],
    url: '/api/commission-note/{commission_note}/items-order',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\CommissionNote\ReorderCommissionNoteItemsController::__invoke
* @see app/Http/Controllers/CommissionNote/ReorderCommissionNoteItemsController.php
* @route '/api/commission-note/{commission_note}/items-order'
*/
ReorderCommissionNoteItemsController.url = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { commission_note: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { commission_note: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            commission_note: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        commission_note: typeof args.commission_note === 'object'
        ? args.commission_note.id
        : args.commission_note,
    }

    return ReorderCommissionNoteItemsController.definition.url
            .replace('{commission_note}', parsedArgs.commission_note.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CommissionNote\ReorderCommissionNoteItemsController::__invoke
* @see app/Http/Controllers/CommissionNote/ReorderCommissionNoteItemsController.php
* @route '/api/commission-note/{commission_note}/items-order'
*/
ReorderCommissionNoteItemsController.put = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: ReorderCommissionNoteItemsController.url(args, options),
    method: 'put',
})

export default ReorderCommissionNoteItemsController